<div class="app-page" style="margin-left: 10px;">
  <h2>{{ "RANKINGLISTS.NEW_LIST" | translate }}</h2>
  @if (this.loadedCats && this.loadedUsers && this.loadedList) {
    <form #selectForm [formGroup]="_form" (ngSubmit)="submit()" >
      <!-- <mat-tab-group>
      <mat-tab label="General">
        <br/> -->
        <div >
          <mat-form-field  appearance="fill" style="min-width: 350px;">
            <mat-label>{{ "RANKINGLISTS.NAME" | translate }}</mat-label>
            <input matInput  formControlName="Description" autocomplete="false" >
          </mat-form-field>
          <br/>
          <mat-form-field class="example-full-width" appearance="fill"  style="min-width: 350px;">
            <mat-label>{{ "RANKINGLISTS.CATEGORY" | translate }}</mat-label>
            <input type="text" matInput formControlName="Category" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete"  >
              @for (option of filteredCategories | async; track option) {
                <mat-option [value]="option" style="color: white;">
                  {{option}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      <!--  </mat-tab>
      <mat-tab label="Sharing"> -->
            <label>{{ "RANKINGLISTS.VIEW" | translate }}</label>                    
            <label style="margin-left: 60px;">
              {{ "RANKINGLIST.EDIT" | translate }}
            </label>
          <br/>
        <!--  <mat-selection-list #sharinglist style="height: 350px;" [multiple]="true"  >
        <mat-list-option *ngFor="let usr of this.users" [value]="usr.User_Id" >
          <h4 mat-line>{{ usr.LastName }}, {{ usr.FirstName }} </h4>
        </mat-list-option>
      </mat-selection-list> -->
      @if (this.PlayerListSecurity) {
        <div style="max-height: 350px; overflow-y: scroll; border: gray 1px solid;" formArrayName="PlayerListSecurity">
          @for (access of PlayerListSecurity.controls; track access; let i = $index) {
            <div>
              <div [formGroupName]="i" STYLE="display: flex; flex-direction: row; border-bottom: gray solid 1px;">
                <div  style="width: 100px;">
                  <mat-checkbox formControlName="value"></mat-checkbox>
                </div>
                  <div  style="width: 100px;">
                    <mat-checkbox formControlName="CanEdit"></mat-checkbox>
                </div>
                <div style="width: 200px;" >
                  {{getScout(access.get('UserId')?.value)}}
                </div>
              </div>
            </div>
          }
        </div>
      }
    <!--     </mat-tab>
  </mat-tab-group> -->
  <br/>
  <button mat-raised-button type="submit" color="accent">{{ "GENERAL.SAVE" | translate | uppercase }}</button>
  <button mat-button type="button" (click)="cancel()">{{ "GENERAL.CANCEL" | translate | uppercase }}</button>
</form>
} @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
</div>